var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C5.37258 0 0 5.37258 0 12V23C0 23.5523 0.447716 24 1 24H12C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM12 7.5L11.9125 7.50505C11.5395 7.54837 11.25 7.86537 11.25 8.25V11.25H8.25L8.16253 11.255C7.78953 11.2984 7.5 11.6154 7.5 12L7.50505 12.0875C7.54837 12.4605 7.86537 12.75 8.25 12.75H11.25V15.75L11.255 15.8375C11.2984 16.2105 11.6154 16.5 12 16.5L12.0875 16.495C12.4605 16.4516 12.75 16.1346 12.75 15.75V12.75H15.75L15.8375 12.745C16.2105 12.7016 16.5 12.3846 16.5 12L16.495 11.9125C16.4516 11.5395 16.1346 11.25 15.75 11.25H12.75V8.25L12.745 8.16253C12.7016 7.78953 12.3846 7.5 12 7.5Z",
    fill: "#C2C7CB"
  })));
};

export default __webpack_public_path__ + "static/media/plus.14435ba1.svg";
export { SvgComponent as ReactComponent };